export const FOCUS_CONTROL_TIMEOUT = 300;
